import { useCallback } from 'react';
import usePluginHandler from '../../../hooks/usePluginHandler';
import { PluginMessageTypes } from '../../../models/constants';
import { NOOP } from '../../../utils/const';

/**
 * Comportamento nel caso di un IFrame in una Modale.
 */
export default function useIFrameInDialog(onDialogResize = NOOP, onDialogOk = NOOP, onDialogCancel = NOOP) {
  const handleMessages = useCallback((message) => {
    switch (message.type) {
      case PluginMessageTypes.DIALOG_SIZE:
        onDialogResize(message.payload);
        break;
      case PluginMessageTypes.DIALOG_OK:
        onDialogOk(message.payload);
        break;
      case PluginMessageTypes.DIALOG_CANCEL:
        onDialogCancel();
        break;
      default:
    }
  }, [onDialogCancel, onDialogOk, onDialogResize]);
  usePluginHandler(handleMessages);
}
